import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const geVehicleListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `vehicle?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const geVehicleAssignmentListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `vehicle_assignment?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const geKMHistoryListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `km_history?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const geExpenseHistoryListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `expense_history?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const geFuelHistoryListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `fuel_history?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
